import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzTooltipInjectorModule, DzTooltipModule } from '@blk/daisy/combinations/on-screen-help';
import { SharedModule } from '@ddt-web/common';
import { GenericPipesModule } from '@ddt-web/generic-utils';

import { RiskProfileIndicatorComponent } from './risk-profile-indicator.component';

@NgModule({
	declarations: [RiskProfileIndicatorComponent],
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		DzTooltipInjectorModule,
		DzTooltipModule,
		GenericPipesModule
	],
	exports: [RiskProfileIndicatorComponent]
})
export class RiskProfileIndicatorModule { }
